import React from "react"
import {Field, getFormValues} from "redux-form"
import { SelectMenu } from "../forms"
import { connect } from "react-redux"
import { Countries } from "../../api/countries"

let CLSelectMenu = (props) => {


    return <Field name={props.name} title={props.title} component={SelectMenu} options={props.options}/>

};

class CountryListSelectMenu extends React.Component {

    componentWillMount = () => {
        this.props.load(this.props.config);
    };

    render = () => {
        return <CLSelectMenu name={this.props.name} title={this.props.title} options={this.props.options} />
    }
}

const action = (config) => {

    return (dispatch) => {
        Countries(config.refdata).Get().then((countries) => {
            dispatch({
                type : "COUNTRY_LIST_LOAD",
                options : countries
            });
        });
    }
};

CountryListSelectMenu.defaultProps = {
    name : "country" ,
    title : "Country"
};


CountryListSelectMenu = connect( state => {
    return {
        config : getFormValues('config')(state),
        options : state.countries.options
    }

} , (dispatch) => {
    return {
        load : (c) => dispatch( action(c) ),
    }
} )(CountryListSelectMenu);

export {
    CountryListSelectMenu
}
